import React from "react";
import { i18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = {
    hasError: false,
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      // Render the same component with fallbackProps
      const FallbackComponent = React.cloneElement(
        React.Children.only(children) as React.ReactElement<any>,
        {
          content: i18n._(
            msg({
              context:
                "Text shown to the user after the last question could not be processed.",
              message:
                "I'm sorry, I couldn't process the data. Please check your question or try rephrasing your request.",
            }),
          ),
        },
      );
      return FallbackComponent;
    }

    return children;
  }
}

export default ErrorBoundary;
